<template>
  <el-table-column
    prop="serial_number"
    sortable="custom"
    label="Sorszám"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.serial_number }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'serial_number',
  };
</script>
